import { render, staticRenderFns } from "./VideoGuardProfile.vue?vue&type=template&id=3507ac69&"
import script from "./VideoGuardProfile.vue?vue&type=script&lang=js&"
export * from "./VideoGuardProfile.vue?vue&type=script&lang=js&"
import style0 from "./VideoGuardProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports